import { IUseFetchOptionsParams } from '@common/api.models';
import { FETCH_QUERIES_NAME } from '@common/constants';
import { createUseFetchOptionsNoPropsFn } from '@common/selectOptions.services';
import { getAllTagTypeOptionsAsync } from './tag.services';

export const useFetchAllTagTypeOptions = ({ isDirty = false, shouldConvertOptions = false }: IUseFetchOptionsParams) =>
  createUseFetchOptionsNoPropsFn({
    queryName: FETCH_QUERIES_NAME.TAG_TYPE_OPTIONS,
    getOptionsFn: getAllTagTypeOptionsAsync,
    handleOptionsProps: {
      shouldConvertOptions,
      textFieldName: 'name',
    },
    enabled: !isDirty,
  });
